export const PARTNER_PATHS = {
  LIST: "/ihub/partners",
  CREATE: "/ihub/partners",
  DETAIL: "/ihub/partners/:id",
  UPDATE: "/ihub/partners/:id",
  DELETE: "/ihub/partners/:id",

  SETTING_LIST: "/ihub/partners/:partnerId/settings",
  SETTING_CREATE: "/ihub/partners/:partnerId/settings",
  SETTING_DETAIL: "/ihub/partners/:partnerId/settings/:id",
  SETTING_UPDATE: "/ihub/partners/:partnerId/settings/:id",
};
